import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PendingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pending"}/>
}
